<header
  data-test="d6zRHL6_"
  class="header-main header-main_fixed position-fixed"
  data-sticky=""
  style="width: 1527.27px"
>
  <div data-test="d5SwcU8C" class="header">
    <div data-test="F8E2EMde" class="header__container">
      <div
        data-test="QqAnjOOX"
        class="header__wrap row align-items-center flex-nowrap gutters-20"
      >
        <div data-test="0403Qu98" class="header__col col-auto">
          <button
            data-test="-FrtYlsk"
            class="header__button header__close"
            (click)="onClose()"
          >
            <i data-test="8acF_roc" class="material-icons md-24">close</i>
            <span data-test="2__fv-aq" class="header__close-text d-none">Close</span>
          </button>
        </div>
        <div data-test="v8Qd74NA" class="header__col col">
          <div data-test="GxXwSgQW" class="header__left">
            <div data-test="P7b6sN8s" class="row gutters-16 align-items-center">
              <div data-test="j0qWxaw2" class="col-auto">
                <div data-test="McWWzVcQ" class="header__details">
                  <div data-test="_6vMMlja" class="row flex-nowrap">
                    <div data-test="5Mtg5uH1" class="col-auto pr-0">
                      <md-letter-image
                        data-test="BfTGJyfj"
                        [name]="name"
                        [image]="logo"
                        class="img-square img-square_md"
                      ></md-letter-image>
                    </div>
                    <div data-test="_oV3pqwv" class="col-auto">
                      <h4 data-test="tiAa9uqm" class="header__details-title">
                        {{ title }}
                      </h4>
                      <h2 data-test="ngEyD3pa" class="header__details-name">
                        {{ name }}
                      </h2>
                      <div
                        data-test="fBwKt4vT"
                        class="header__details-label"
                        *ngIf="labelText"
                      >
                        <div data-test="HPAeKaLZ" class="label" [ngClass]="labelClasses">
                          <span data-test="T03Bl35M">{{ labelText }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-test="HcmKCuXW" class="header__col col-auto">
          <div data-test="wDj1rrTF" class="row align-items-center gutters-16">
            <div data-test="Hn5GpxCK" class="col-auto pr-3">
              <div data-test="4xkp10s7" class="position-relative">
                <button
                  data-test="sLrfU3DY"
                  class="button button_link"
                  [mdPopover]="actionsDropdown"
                >
                  <span data-test="8NsisPQA">Actions</span>
                  <span data-test="6Yy_yzJd" class="button__icon button__icon_right">
                    <i
                      data-test="nC6kss4l"
                      class="material-icons md-14"
                      style="margin: 0 -4px"
                    >
                      keyboard_arrow_down
                    </i>
                  </span>
                </button>
                <div
                  data-test="AdWFhn6o"
                  class="dropdown dropdown_bottom-right dropdown_arrow"
                  #actionsDropdown
                  style="right: -8px"
                >
                  <div data-test="a8pB7WC1" class="dropdown__wrap">
                    <ul data-test="4O5ACndd" class="dropdown__menu">
                      <li
                        data-test="W9HbIUHx"
                        class="dropdown__menu-item"
                        *ngFor="let action of actionsList"
                        (click)="onActionCall(action)"
                      >
                        <a data-test="eRakzAht" class="dropdown__menu-link" data-modal="">
                          {{ action }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div data-test="MAja9Ovr" class="col-auto">
              <button
                *ngIf="userPermissions.OBJECTS_SUPPLIER_EDIT"
                data-test="tomBWGu1"
                (click)="onEditEntity()"
                [disabled]="disableEditButton"
                class="header__button button button_green text-uppercase"
              >
                Edit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
